import { Checkbox } from "@/components/ui/checkbox";

export const MobileCard = ({ title, subtitle, badge, body, fields = [], selected, onSelect, onOpen, actions, testid }) => (
  <div role="button" tabIndex={0} onClick={onOpen} className={`rounded-lg border border-border p-4 transition-colors ${selected ? "bg-[#EEF3FA]" : "bg-white active:bg-slate-50"}`} data-testid={testid}>
    <div className="flex items-start gap-3">
      {onSelect && <div onClick={(e) => e.stopPropagation()} className="shrink-0 pt-0.5"><Checkbox checked={!!selected} onCheckedChange={onSelect} aria-label="Select" data-testid={`${testid}-select`} /></div>}
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0 break-words font-semibold text-[#1B4383]">{title}</div>
          {badge}
        </div>
        {subtitle && <div className="mt-0.5 break-words text-[11px] text-muted-foreground">{subtitle}</div>}
        {body && <div className="mt-1 break-words text-sm leading-snug text-slate-800">{body}</div>}
      </div>
    </div>
    {fields.length > 0 && (
      <div className="mt-3 grid grid-cols-2 gap-3 border-t border-border pt-3">
        {fields.map(([label, value]) => (
          <div key={label} className="min-w-0">
            <div className="text-[11px] tracking-wide text-muted-foreground">{label}</div>
            <div className="mt-0.5 break-words text-xs font-medium text-slate-700">{value}</div>
          </div>
        ))}
      </div>
    )}
    {actions && <div className="mt-3 flex justify-end gap-1.5 border-t border-border pt-3" onClick={(e) => e.stopPropagation()}>{actions}</div>}
  </div>
);
